<template>
	<nk-page commercialAccess="System" :policyClaims="['Settings_Accounting_Document']">
		<template #badges v-if="!data">
			<nk-badge system="accounting">
				<nk-badge-item type="system" modelValue="accounting" :title="$t(`setting.title`)"></nk-badge-item>
				<nk-badge-item type="system" modelValue="accounting" :title="$t(`setting.documentSettings.title`)"></nk-badge-item>
			</nk-badge>
		</template>

		<div class="container-fluid form-container h-100">
			<div class="nk-card h-100 d-flex flex-column">
				<div>
					<nk-col-form-group :label="$t('setting.doc.f.KeepCodeSerial') + ':'" :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 1 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
						<nk-switch v-model="localData.documentSettings.keepCodeSerial" :tabindex="101" startup>
						</nk-switch>
					</nk-col-form-group>
					<nk-col-form-group :label="$t('setting.doc.f.onlyDeleteByCreator') + ':'" :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 1 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
						<nk-switch v-model="localData.documentSettings.deleteDocumentByCreator" :tabindex="101" startup>
						</nk-switch>
					</nk-col-form-group>
					<nk-col-form-group :label="$t('setting.doc.f.row-validation') + ':'" :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 5 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
						<nk-multichoice2 v-model="localData.documentSettings.requiredFields" @update:modelValue="requiredFieldsSelectionChange" :data="requiredFieldItems" :options="componentOptions.requiredFields" :tabindex="102" ref="requiredFields"></nk-multichoice2>
					</nk-col-form-group>
					<nk-col-form-group :label="$t('setting.doc.f.taxCalculationSection') + ':'" :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 5 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
						<nk-dropdown v-model="localData.documentSettings.taxCalculationSection" :data="taxCalculationSectionItems" :options="componentOptions.taxCalculationSection" :tabindex="103"></nk-dropdown> </nk-col-form-group>
				</div>
				<div class="flex-grow-1">
					<label>{{ $t('setting.documentTypeSettings.title') + ':' }}</label>
					<nk-table v-model="selectedRow" :data="docTypes" :options="docTypeTableOptions" ref="docTypeList" tabindex="105" startup>
					</nk-table>
				</div>
			</div>
		</div>
	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import Input from '~/components/general/nikan-input.vue'
	import validators, { Checker, VRequired } from '~/statics/validators'
	import $sc from '~/plugins/shortcut.collection.js'
	import Dropdown from '~/components/general/dropdown.vue'
	import { post } from '~/plugins/nikan-api'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import Endpoints from '@nikan/endpoints'
	import BooleanLabel from '~/components/form/boolean-label'

	export default {
		props: {
			data: {},
			options: {},
		},
		modal: {
			helpTag: 'SettingsDocument'
		},
		data() {
			return {
				taxCalculationSectionItems: ['Receipt', 'BuyFactor'],
				componentOptions: {
					requiredFields: {
						searchable: true,
						required: true,
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: function (item) {
							return item.name
						},
						searchableFields: ['name'],
					},
					taxCalculationSection: {
						searchable: true,
						required: true,
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: function (item) {
							return this.$t(`setting.doc.f.${item}`)
						},
						searchableFields: ['name'],
					}
				},
				requiredFieldItems: [{ id: 'trackNumber', name: this.$t('setting.doc.f.trackNumber') }, { id: 'trackDate', name: this.$t('setting.doc.f.trackDate') }, { id: 'count', name: this.$t('setting.doc.f.count') }],
				settings: {
					loadFromRemote: true,
				},
				defaultData: {
					documentSettings: {
						keepCodeSerial: true,
						deleteDocumentByCreator: false,
						requiredFields: [],
					},
				},
				remoteData: null,
				docTypeTableOptions: {
					activeRowDisabled: true,
					editable: false,
					searchable: false,
					allowNewRow: false,
					displayOrderEnabled: false,
					buttons: {
						addBtn: {
							handler: this.addDocTypeRow,
							options: {
								visible: false,
							},
						},
						deleteBtn: {
							handler: this.deleteDocTypeRow,
							options: {
								visible: false,
							},
						}
					},
					// prepareNewRow: () => {
					// 	return {
					// 		companyId: emptyId,
					// 		insert: false,
					// 		nonBalance: false,
					// 		insertBySubsystems: false,
					// 		edit: false,
					// 		delete: false,
					// 		reports: false,
					// 		documentOperations: false,
					// 	}
					// },
					columns: [
						{
							name: 'rowNumber',
							title: this.$t('row-number'),
							searchable: true,
							sortable: true,
							editable: false,
							width: 50,
							entering: false,
							resizable: false,
						},
						{
							name: 'name',
							title: this.$t('document.docType.f.name'),
							edit: {
								component: Input,
								options: {
									mode: 'string',
								},
							},
							searchable: true,
							sortable: false,
							editable: false,
							width: 100,
							validators: validators(new VRequired()),
						},
						{
							name: 'systemDocType',
							title: this.$t('document.docType.f.systemDocType'),
							width: '150',
							search: {
								searchFields: ['name'],
							},
							editable: true,
							entering: (row, col) => { return row.systemDocType === 'Unknown' },
							validators: validators('required'),
							view: {
								options: {
									format: (item) => {
										return this.$t('document.docType.types.' + item.toLowerCase())
									},
								},
							},
							edit: (row, col) => {
								return {
									component: Dropdown,
									options: {
										selectorWidth: '200px',
										remoteSearch: false,
										placeholder: this.$t('select-it'),
										getDataFromOptions: true,
										locateSelectorBasedOnDocument: true,
										searchPrefix: 'document.docType.types',
										display: (item) => {
											return this.$t('document.docType.types.' + item.toLowerCase())
										},
										data: this.systemDocTypes.map((x) => x.key),
									},
								}
							},
						},
						{
							name: 'periority',
							title: this.$t('document.docType.f.periority'),
							// edit: {
							// 	component: Input,
							// 	options: {
							// 		mode: 'integer',
							// 	},
							// },
							searchable: true,
							sortable: false,
							editable: false,
							entering: false,
							width: 80,
							align: 'center'
						},
						{
							name: 'insert',
							title: this.$t('document.docType.f.insert'),
							type: 'dropdown',
							search: {
								prefix: 'boolean-allow-disallow',
								useTranslate: true,
							},
							view: {
								component: BooleanLabel,
							},
							// edit: {
							// 	component: Switch,
							// },
							// editable: (row) => row.rowState === 'new',
							editable: false,
							entering: false,
							width: 170,
						},
						{
							name: 'nonBalance',
							title: this.$t('document.docType.f.nonBalance'),
							type: 'dropdown',
							search: {
								prefix: 'boolean-allow-disallow',
								useTranslate: true,
							},
							view: {
								component: BooleanLabel
							},
							// edit: {
							// 	component: Switch,
							// },
							// editable: (row) => row.rowState === 'new',
							editable: false,
							entering: false,
							width: 160,
						},
						{
							name: 'insertBySubsystems',
							title: this.$t('document.docType.f.insertBySubsystems'),
							type: 'dropdown',
							search: {
								prefix: 'boolean-allow-disallow',
								useTranslate: true,
							},
							view: {
								component: BooleanLabel
							},
							// edit: {
							// component: Switch,
							// },
							// editable: (row) => row.rowState === 'new',
							editable: false,
							entering: false,
							width: 230,
						},
						{
							name: 'edit',
							title: this.$t('document.docType.f.edit'),
							type: 'dropdown',
							search: {
								prefix: 'boolean-allow-disallow',
								useTranslate: true,
							},
							view: {
								component: BooleanLabel
							},
							// edit: {
							// 	component: Switch,
							// },
							// editable: (row) => row.rowState === 'new',
							editable: false,
							entering: false,
							width: 150,
						},
						{
							name: 'delete',
							title: this.$t('document.docType.f.delete'),
							type: 'dropdown',
							search: {
								prefix: 'boolean-allow-disallow',
								useTranslate: true,
							},
							view: {
								component: BooleanLabel
							},
							// edit: {
							// 	component: Switch,
							// },
							// editable: (row) => row.rowState === 'new',
							editable: false,
							entering: false,
							width: 150,
						},
						{
							name: 'reports',
							title: this.$t('document.docType.f.reports'),
							type: 'dropdown',
							search: {
								prefix: 'boolean-allow-disallow',
								useTranslate: true,
							},
							view: {
								component: BooleanLabel
							},
							// edit: {
							// 	component: Switch,
							// },
							// editable: (row) => row.rowState === 'new',
							editable: false,
							entering: false,
							width: 200,
						},
						{
							name: 'documentOperations',
							title: this.$t('document.docType.f.documentOperations'),
							type: 'dropdown',
							search: {
								prefix: 'boolean-allow-disallow',
								useTranslate: true,
							},
							view: {
								component: BooleanLabel
							},
							// edit: {
							// 	component: Switch,
							// },
							// editable: (row) => row.rowState === 'new',
							editable: false,
							entering: false,
							width: 'auto',
						},
					],
				},
				systemDocTypes: [],
				docTypes: null,
				selectedRow: null,
				validators: {
					taxCalculationSection: validators('required')
				},
				btnAdd: {
					title: '',
					isPrimary: false,
					icon: 'plus',
				},
				btnDelete: {
					title: '',
					icon: 'trash',
					isPrimary: false,
				},
				saveDocumentSettingButton: {
					title: this.$t('save'),
					shortcut: $sc.find('save'),
					isPrimary: true,
					icon: 'save',
					handle: (button, page, e) => {
						e.preventDefault()
						this.saveSettings()
					},
					policyClaims: 'Settings_Accounting_DocumentEdit',
				},
			}
		},
		computed: {
			localSettings() {
				return _.extend({}, this.settings, this.options)
			},
			localData() {
				if (this.localSettings.loadFromRemote) {
					return this.remoteData
				} else {
					return this.data || this.defaultData
				}
			},
		},
		created() {
			if (this.localSettings.loadFromRemote) {
				this.remoteData = this.defaultData
			}
			this.docTypeTableOptions.editable = true
		},
		mounted() {
			if (!this.data)
				this.getSetting()

			this.prepareWindow(this.$t('setting.documentSettings.title'), [
				this.saveDocumentSettingButton,
			])

			this.getDocTypes()
			this.getSystemDocTypes()
		},
		watch: {
			data: {
				immediate: true,
				handler(val) {
					if (val)
						this.prepareData(val)
				}
			}
		},
		methods: {
			getSystemDocTypes() {
				this.systemDocTypes = this.getPropertiesByGroup('SystemDocumentTypes')
			},
			getDocTypes() {
				var wait = this.$wait(this.$refs.docTypeList.$el)
				post(Endpoints.getUrl('documentTypes.list'), { sorts: [{ name: 'periority', direction: 'Ascending' }] })
					.then((result) => {
						wait.end()
						this.docTypes = result.data.items
						this.defer(() => {
							this.$refs.docTypeList.table_Focused()
						}, 500)
					})
					.catch(() => {
						wait.end()
					})
			},
			prepareData(data) {
				if (!data.documentSettings.requiredFieldsJson)
					data.documentSettings.requiredFieldsJson = JSON.stringify(this.defaultData.documentSettings.requiredFields)

				data.documentSettings.requiredFields = (JSON.parse(data.documentSettings.requiredFieldsJson) || []).map(x => { return { id: x, name: this.$t(`setting.doc.f.${x}`) } })
				this.localData.documentSettings = data.documentSettings
			},
			getSetting() {
				var wait = this.$wait(this.$el)
				post(Endpoints.getUrl('settings.get'), null, null, { preventConcurrent: false })
					.then((result) => {
						wait.end()
						this.prepareData(result.data)
					})
					.catch(() => {
						wait.end()
					})
			},
			commitTableChanges(wait) {
				return this.$refs.docTypeList.commitChanges().catch((errorRows) => {
					wait.end()
					if (Array.isArray(errorRows)) {
						var rowNumbers = errorRows.map((x, i) => x.rowNumber).join(',')
						dialog({
							title: this.$t('document.docType.m.save-docType-title'),
							body: this.$t('document.docType.m.save.error.rows', { rowNumbers }),
							type: 'error',
							isPrimary: true,
						})
					} else {
						dialog({
							title: this.$t('document.docType.m.save-docType-title'),
							body: errorRows.message,
							type: 'error',
							isPrimary: true,
						})
					}
				})
			},
			saveDocTypes() {
				var wait = this.$wait(this.$refs.docTypeList.$el)
				this.commitTableChanges(wait).then((docTypes) => {
					var data = {
						Items: docTypes,
					}

					post(Endpoints.getUrl('documentTypes.modify'), data)
						.then((result) => {
							wait.end()
							this.cache_remove('documentTypes_key')

							if (!this.grandParentType() === 'modal')
								this.getDocTypes()
						})
						.catch(() => {
							wait.end()
							this.defer(() => this.$refs.docTypeList.$el.focus(), 100)
						})
				})
			},
			validateInputs() {
				let checker = new Checker(type => this.$t(`setting.doc.f.${type}`))
				let errors = checker.test(this.localData.documentSettings, this.validators)

				this.validationToast(errors)
				return errors.length === 0
			},
			saveSettings() {
				if (!this.validateInputs()) return

				this.$refs.docTypeList.commitChanges().then((docTypes) => {
					if (!docTypes.map(x => x.periority).isDistinct())
						return this.$toast(this.$t('setting.doc.m.error-periority-duplicate'), { type: 'error' })

					var wait = this.$wait(this.grandParent)
					this.saveDocTypes()
					this.localData.type = 'FiscalPeriod'
					post(Endpoints.getUrl('settings.modify'), this.localData)
						.then((result) => {
							wait.end()
							this.$toast(this.$t('msg.create-success'), { type: 'success' })

							if (this.grandParentType() === 'modal')
								this.resolve()
						})
						.catch(() => {
							wait.end()
						})
				})
			},
			addDocTypeRow(button, e) {
				e.preventDefault()

				if (!this.$refs.docTypeList) return

				this.$refs.docTypeList.row_tryAddEmpty()
			},
			deleteDocTypeRow(button, e) {
				e.preventDefault()

				if (!this.$refs.docTypeList) return

				this.$refs.docTypeList.row_deleteSelectedRows()
			},
			requiredFieldsSelectionChange(items) {
				this.localData.documentSettings.requiredFieldsJson = JSON.stringify(items.map(x => x.id))
			},
			commitData() {
				return this.localData
			}
		},
	}
</script>
<style></style>
